import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  MarketingContact,
  UpdateContactConsentPayload
} from "../../marketing.types";

export const requestUpdateContactConsent = async ({
  phone,
  optedIn
}: UpdateContactConsentPayload): Promise<MarketingContact> => {
  return await instance.post(
    `${ApiRoutesMarketing.Contacts}/${encodeURIComponent(phone)}/consent`,
    { optedIn }
  );
};
